import { render, staticRenderFns } from "./GroupMembers.vue?vue&type=template&id=554ddb46&scoped=true"
import script from "./GroupMembers.vue?vue&type=script&lang=js"
export * from "./GroupMembers.vue?vue&type=script&lang=js"
import style0 from "./GroupMembers.vue?vue&type=style&index=0&id=554ddb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ddb46",
  null
  
)

export default component.exports